import Vue from 'vue'
import Vuetify, {
    VChip,
    VChipGroup,
    VCol,
    VIcon,
    VImg,
    VListItem,
    VListItemContent,
    VListItemTitle,
    VListItemSubtitle,
    VProgressCircular,
    VTooltip
} from 'vuetify/lib'
import Config from '@/common/vuetify/config'

Vue.use(Vuetify, {
    components: {
        VChip,
        VChipGroup,
        VCol,
        VIcon,
        VImg,
        VListItem,
        VListItemContent,
        VListItemTitle,
        VListItemSubtitle,
        VProgressCircular,
        VTooltip
    }
})

export default new Vuetify(Config)
